import { enableableField, MeshKeyMethodVersion } from "@somewear/model";
import {
	baseWorkspaceDeviceDefaultsRequestSchema,
	SURVIVABLE_BASELINE_SETTINGS,
	workspaceDefaultsFieldsSchema,
} from "@somewear/workspace";
import { z } from "zod";

export interface OrganizationPickerOption {
	name: string;
	id: string;
}

export const organizationWorkspaceDefaultsSchema = workspaceDefaultsFieldsSchema.extend({
	organizationId: z.string(),
	meshKeyMethodVersion: enableableField(
		z
			.nativeEnum(MeshKeyMethodVersion)
			.default(SURVIVABLE_BASELINE_SETTINGS.meshKeyMethodVersion),
		SURVIVABLE_BASELINE_SETTINGS.meshKeyMethodVersion !== MeshKeyMethodVersion.UNKNOWN,
	),
});

export const organizationWorkspaceDefaultsRequestSchema =
	baseWorkspaceDeviceDefaultsRequestSchema.extend({
		// Request settings
		organizationId: z.string(),
		meshKeyMethodVersion: z.number(),
	});

export type OrganizationWorkspaceDefaultsSchema = z.infer<
	typeof organizationWorkspaceDefaultsSchema
>;
export type OrganizationWorkspaceDefaultsRequestSchema = z.infer<
	typeof organizationWorkspaceDefaultsRequestSchema
>;
